<div [ngClass]="{'hidden': isNotVisible}" >
    <p class="timer-text">Tiempo restante: {{ timeLeft }} segundos</p>
</div>